import React, { useState, useEffect } from "react";

export default function IslandVideo({ webmSrc, mp4Src, className }) {
	const [supportsWebM, setSupportsWebM] = useState(null);

	useEffect(() => {
		// Créer un élément video temporaire pour tester le support
		const video = document.createElement("video");

		// Tester le support de WebM VP9 avec transparence
		const webmSupport = video.canPlayType('video/webm; codecs="vp9"');

		// Détecter Safari : Safari ment sur le support de VP9 avec canal alpha
		// Safari peut lire VP9 mais PAS avec transparence (alpha channel)
		const isSafari =
			/^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
			/iPhone|iPad|iPod/.test(navigator.userAgent);

		// Safari dit qu'il supporte VP9 mais ne supporte PAS le canal alpha (transparence)
		// On force HEVC pour Safari, même s'il dit supporter VP9
		const shouldUseWebM = !isSafari && webmSupport !== "";

		// Firefox et Chrome supportent WebM VP9 avec alpha
		// Safari supporte HEVC avec alpha mais pas VP9 avec alpha
		setSupportsWebM(shouldUseWebM);
	}, []);

	// Attendre la détection du navigateur avant d'afficher les vidéos
	// Sinon Safari charge WebM pendant le state null et ne recharge pas après
	if (supportsWebM === null) {
		return null;
	}

	// La clé force React à recréer l'élément video si l'ordre change
	return (
		<video key={supportsWebM ? "webm" : "hevc"} autoPlay muted loop playsInline className={className}>
			{supportsWebM ? (
				<>
					<source src={webmSrc} type='video/webm; codecs="vp9"' />
					<source src={mp4Src} type='video/mp4; codecs="hvc1"' />
				</>
			) : (
				<>
					<source src={mp4Src} type='video/mp4; codecs="hvc1"' />
					<source src={webmSrc} type='video/webm; codecs="vp9"' />
				</>
			)}
		</video>
	);
}
